














































































































import Vue from "vue";
import MenuWingComp from "./MenuWingComp.vue";
import AnmeldungComp from "./AnmeldungComp.vue";
import ListAnmeldungComp from "./ListAnmeldungComp.vue";
import KommentarComp from "./KommentarComp.vue";
import { MyActions } from "@/models/Store/State";
import { Termin } from "models/Termin";
import { Encounter } from "models/Encounter";

export default Vue.extend({
	name: "TerminToolbarComp",
	components: { KommentarComp, ListAnmeldungComp, AnmeldungComp, MenuWingComp },
	data: () => ({
		showExtraRoles: false,
	}),
	computed: {
		headline: function(): string {
			if (this.termin.endtime) {
				return `${this.termin.dateString} ${this.termin.time} - ${this.termin.endtime}`;
			} else {
				return `${this.termin.dateString} ${this.termin.time}`;
			}
		},
		lockIcon: function(): string {
			return this.locked ? "lock" : "lock_open";
		},
		locked: function(): boolean {
			return this.$vStore.getters.isLocked;
		},
		role: function(): number {
			return this.$vStore.getters.raidRole;
		},
		termin: function(): Termin {
			return this.$vStore.getters.termin;
		},
		active: function(): any {
			return this.$vStore.getters.isActive;
		},
	},
	methods: {
		addBoss: function(info: Encounter): void {
			this.$vStore.dispatch(MyActions.AddBoss, info);
		},
		openArchiveDialog: function(): void {
			this.$vStore.dispatch(MyActions.OpenDialog, "archive");
		},
		refresh: function(): void {
			this.$vStore.dispatch(MyActions.Refresh);
		},
		toggleLocked: async function(): Promise<void> {
			await this.$vStore.dispatch(MyActions.ToggleLocked);
		},
		openDeleteDialog: function(): void {
			this.$vStore.dispatch(MyActions.OpenDialog, "delete");
		},
		openShareDialog: function(): void {
			this.$vStore.dispatch(MyActions.OpenDialog, "share");
		},
		openErsatzDialog: function(): void {
			this.$vStore.dispatch(MyActions.OpenDialog, "ersatz");
		},
		uploadLog: function(): void {
			this.$vStore.dispatch(MyActions.ToggleUpload);
		},
		extraRolesChanged: function(): void {
			this.$emit("extraRolesChanged", this.showExtraRoles);
		},
	},
});
